import React, { type PropsWithChildren } from 'react';

import { type Store } from '../../../common/types';
import { UserMenuDataShapesProvider } from '../user-menu-data-shapes-provider';
import { UserSideNavDataStoreProvider } from '../user-side-nav-data-store-provider';

type StoreProvidersProps = PropsWithChildren<Store>;

export function StoreProviders(props: StoreProvidersProps) {
	const { children, userMenuData, userSideNavData, setUserMenuData, setUserSideNavData } = props;

	return (
		<UserMenuDataShapesProvider rawUserMenuData={userMenuData} setUserMenuData={setUserMenuData}>
			<UserSideNavDataStoreProvider
				setUserSideNavData={setUserSideNavData}
				userSideNavData={userSideNavData}
			>
				{children}
			</UserSideNavDataStoreProvider>
		</UserMenuDataShapesProvider>
	);
}
